export default {
  name: "Map",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "m28.5 7.7-8-4.57a.975.975 0 0 0-.99 0L12 7.42 4.5 3.13a.993.993 0 0 0-1 0c-.31.18-.5.51-.5.87v19.43c0 .36.19.69.5.87l8 4.57c.31.18.68.18.99 0l7.5-4.29 7.5 4.29c.31.18.69.17 1 0 .32-.18.51-.51.51-.87V8.57c0-.36-.19-.69-.5-.87zM13 9.15l6-3.43v17.13l-6 3.43V9.15zM5 5.72l6 3.43v17.13l-6-3.43V5.72zm22 20.56-6-3.43V5.72l6 3.43v17.13z",
  },
}
